import ReplayIcon from '@mui/icons-material/Replay';
import { DialogContentText } from '@mui/material';
import { GridActionsCellItem } from '@mui/x-data-grid-premium';
import { EnhancedDialog } from 'components/enhanced';
import toast from 'shared/utils/toast';
import { useState } from 'react';

interface ConfirmationRestoreTableDialogProps {
  label?: string;
  message?: string;
  onConfirm: () => void | Promise<void>;
  // Needed because `getActions` returns an array of elements and this
  // codebase's TS/ESLint setup requires an explicit `key` attribute.
  key?: any;
}

export default function ConfirmationGridRestoreDialog({
  label,
  message,
  onConfirm
}: ConfirmationRestoreTableDialogProps) {
  const [openDialog, setOpenDialog] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const handleConfirm = async () => {
    try {
      setIsSubmitting(true);
      await onConfirm();
      setOpenDialog(false);
    } catch (e: any) {
      // Make failures visible; otherwise it looks like "nothing happens".
      const detail =
        e?.response?.data?.error ||
        e?.response?.data?.detail ||
        e?.message ||
        'Errore durante il ripristino';
      toast.error(String(detail));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <GridActionsCellItem
        showInMenu
        label={label || 'Ripristina'}
        icon={<ReplayIcon />}
        onClick={(e) => {
          e.stopPropagation();
          setOpenDialog(true);
        }}
      />
      <EnhancedDialog
        open={openDialog}
        onSubmit={handleConfirm}
        onClose={handleCloseDialog}
        isSubmitting={isSubmitting}
        title="Conferma ripristino">
        <DialogContentText>
          {message ?? "Vuoi ripristinare l'oggetto selezionato?"}
        </DialogContentText>
      </EnhancedDialog>
    </>
  );
}
